import { updateTodoItem } from '@erikdakoda/todo/ai-tools/updateTodoItem';
import { registerAiTool } from '@erikdakoda/ai-tool/aiToolRegistry';

registerAiTool(updateTodoItem);
